import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';

export interface AgentToolFormData {
  id: string;
  toolKey: string;
  description: string;
}

interface EditAgentToolModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (formData: AgentToolFormData) => void;
  saving: boolean;
  saveError: string | null;
  initialData: AgentToolFormData | null;
}

const EditAgentToolModal: React.FC<EditAgentToolModalProps> = ({
  open,
  onClose,
  onSave,
  saving,
  saveError,
  initialData,
}) => {
  const [formData, setFormData] = useState<AgentToolFormData>({
    id: '',
    toolKey: '',
    description: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        toolKey: initialData.toolKey,
        description: initialData.description,
      });
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Editar Herramienta</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {saveError && (
              <Alert severity="error">{saveError}</Alert>
            )}

            <TextField
              label="Clave de Herramienta"
              value={formData.toolKey}
              disabled
              fullWidth
            />

            <TextField
              label="Descripción"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              multiline
              rows={6}
              fullWidth
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" disabled={saving}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={saving}
            startIcon={saving ? <CircularProgress size={20} /> : undefined}
          >
            {saving ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditAgentToolModal;
